import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import EditPropertyContainer from './containers/edit-property/edit-property.container';
import PropertiesListContainer from './containers/properties-list/properties-list.container';
/**
 * function PropertyModule components
 */
export const PropertyModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.PROPERTY_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.PROPERTY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.PROPERTY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={PropertiesListContainer}
      />
      <Route
        path={(APP_ROUTES.PROPERTY_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH}
        component={EditPropertyContainer}
      />
    </>
  );
};
